export default "__VITE_ASSET__379ee07d__"